module.exports = __webpack_public_path__ + "static/img/Martin-Jauschneg-Karte.0bfaaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Martin-Jauschneg-Karte.png
// module id = 406
// module chunks = 8